import "../../../../styles/page/shoppingCart.scss";
import "../../../../styles/historyDocumentsComponent.scss";

import Icon, {iconColor, iconTypes} from "../../../common/components/Icon.jsx";
import { ProductViewListHeader, ProductViewListItem } from "../product/ProductViewListItem.jsx";
import { SubMenu, SubMenuItem } from "../../../common/components/SubMenu.jsx";
import { Tag, tagTypes } from "../../../common/components/Tag.jsx";
import { estimatedTobaccoReturnValue, getTobaccoReturnLineCount, isAllBagNumberValidated } from "../../util/historyUtil";

import CounterField from "../../../common/components/CounterField";
import LabelField from "../../../common/components/LabelField.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import RadioButton from "../../../common/components/RadioButton.jsx";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../../common/components/ResponsiveRows";
import Scroll from "../../../common/components/Scroll.jsx";
import TextField from "../../../common/components/TextField.jsx";
import YesNoModal from "../../../common/components/YesNoModal";
import { getPropertyValue } from "../../../common/util/changeUtils";
import { scssVariables } from "../../../common/util/config.jsx";

class TobaccoSupplierNumberField extends React.PureComponent {
    constructor(props){
        super(props);

        this.onEdit = this.onEdit.bind(this);
        this.onValidate = this.onValidate.bind(this);
    }

    onEdit(change) {
        const {
            edditSupplierBag,
            bagIndex,
            supplierId,
        } = this.props;
        edditSupplierBag(supplierId, bagIndex, {
            ...change,
            bagNumberValidated: false
        });
    }
    onValidate() {
        const {
            validateBagNumber,
            supplierId,
            bagIndex,
        } =  this.props;
        validateBagNumber(supplierId, bagIndex);
    }

    render() {
        const {
            tobacco,
            supplierIndex,
            bagIndex,
            localization,
            maxLength,
        } = this.props;
        const isValidated = getPropertyValue(tobacco,["bagSupplier",supplierIndex,"bags",bagIndex,"bagNumberValidated"]);
        return (
            <React.Fragment>
                <TextField
                    className={`input-container left-borderless ${tobacco.trySubmit && !isValidated ? "error":""}`}
                    source={tobacco.bagSupplier[supplierIndex].bags[bagIndex]}
                    property={"bagNumber"}
                    usingSubmit={true}
                    iconType={isValidated?iconTypes.check:undefined}
                    iconColor={iconColor.dark}
                    onEdit={this.onEdit}
                    invisibleBackground={true}
                    disabled={!tobacco.bagSupplier[supplierIndex].bags[bagIndex].bagNumberEditable}
                    maxLength={maxLength}
                />
                {!isValidated && (
                    <button className="btn" onClick={this.onValidate} style={{marginTop:"4px",marginBottom:"4px",float:"right"}}>{localization.text("history","validateBagNo")}</button>
                )}
            </React.Fragment>
        );
    }
}
TobaccoSupplierNumberField.propTypes = {
    tobacco: PropTypes.object.isRequired,
    edditSupplierBag: PropTypes.func.isRequired,
    bagIndex: PropTypes.number.isRequired,
    supplierId: PropTypes.string.isRequired,
    productId: PropTypes.string.isRequired,
    supplierIndex: PropTypes.number.isRequired,
    localization: PropTypes.object.isRequired,
    validateBagNumber: PropTypes.func.isRequired,
    maxLength: PropTypes.number.isRequired,
};

/**
 * Renders a button for adding a bag
 * @param {object} props 
 * @returns {node}
 */
function TobaccoAddBagButton({product, addTobaccoBag, canAddBag, localization}){
    /**
     * Created a bag
     * @returns {*}
     */
    function onClickAddBag() {
        addTobaccoBag(product);
    }
    return (
        <button className="btn history-tobacco-add-bag" disabled={!canAddBag || !product} onClick={onClickAddBag}>
            {localization.text("history","addTobaccoBag")}
        </button>
    );
}
TobaccoAddBagButton.propTypes = {
    product: PropTypes.object,
    addTobaccoBag: PropTypes.func.isRequired,
    canAddBag: PropTypes.bool.isRequired,
    localization: PropTypes.object.isRequired,
};

class TobaccoReturnCart extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            expanded: this.props.deviceType!=="xs",
        };

        this.onClearAll = this.onClearAll.bind(this);
        this.onClickClear = this.onClickClear.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onClickExpand = this.onClickExpand.bind(this);
        this.onClickMinimize = this.onClickMinimize.bind(this);
        this.onClickSubmitTobaccoReturn = this.onClickSubmitTobaccoReturn.bind(this);
        this.onClickSaveTobaccoReturn = this.onClickSaveTobaccoReturn.bind(this);
        this.prepareCart = this.prepareCart.bind(this);
        this.setRef = this.setRef.bind(this);

        this.elements = [];
    }

    UNSAFE_componentWillMount() {
        this.props.editTobacco({
            pickUpByEngrospartner: this.props.pickupTobaccoDefault,
        });
    }

    calculateListHeight() {
        const {
            height,
        } = this.props;

        let listHeight = height;

        //top menu
        listHeight -= parseInt(scssVariables.menuHeight);
        //progressbar
        listHeight -= parseInt(scssVariables.progresbarHeight);
        //second menu
        listHeight -= parseInt(scssVariables.menuHeight);
        //bottom section
        listHeight -= parseInt(scssVariables.tobaccoCartDetailHeight);

        return listHeight;
    }

    onClearAll(event){
        event.stopPropagation();
        event.preventDefault();

        this.props.clearAll();
        this.props.setModal(null);
    }
    onClickClear(){
        const {
            localization,
            setModal,
        } = this.props;
        setModal(<YesNoModal
            localization={localization}
            onYes={this.onClearAll}
            onNo={this.closeModal}
            onCancel={this.closeModal}
            onCloseModal={this.closeModal}
            labelHeader={localization.text("history","areYouSure")}
            label={localization.text("history","doYouReallyWantClearTobacco")}
        />);
    }
    closeModal(event) {
        if( event ){
            event.stopPropagation();
            event.preventDefault();
        }
        
        this.props.setModal(null);
    }
    onClickExpand() {
        this.setState({
            expanded: true,
        });
    }
    onClickMinimize() {
        this.setState({
            expanded: false,
        });
    }
    onClickSubmitTobaccoReturn() {
        const {
            localization,
            submitTobaccoReturn,
            setModal,
            tobacco,
        } = this.props;

        const errorValidation = isAllBagNumberValidated(tobacco);

        if(errorValidation)
        {
            this.scrollToMyRef(this.elements[`${errorValidation.supplierId}-${errorValidation.bagId}`]);
            return;
        }

        submitTobaccoReturn( (message, downloadPdf) => {
            setModal(
                <YesNoModal
                    localization={localization}
                    // eslint-disable-next-line react/jsx-no-bind
                    onYes={() => {downloadPdf();this.closeModal();}}
                    onNo={this.closeModal}
                    onCloseModal={this.closeModal}
                    headerColor={"#4b587b"}
                    labelHeader={localization.text("history","wantToSaveFile")}
                    label={message}
                    label2={localization.text("history","wantToSavePdf")}
                />
            );
        });
    }

    scrollToMyRef = (ref) => ref.scrollIntoView();
     
    onClickSaveTobaccoReturn()
    {
        const {
            saveTobaccoReturn,
            tobacco,
        } = this.props;

        saveTobaccoReturn(false);

        const errorValidation = isAllBagNumberValidated(tobacco);

        if(errorValidation)
        {
            //var test = this.elements[`${errorValidation.supplierId}-${errorValidation.bagId}`];
            this.scrollToMyRef(this.elements[`${errorValidation.supplierId}-${errorValidation.bagId}`]);
        }
    }

    setRef(element, supplier, bagId) {
        this.elements[`${supplier}-${bagId}`] = element;
    }


    prepareCart() {
        const {
            deviceType,
            localization,
            tobacco,
            addRemoveProductToTobaccoBag,
            addTobaccoBag,
            edditSupplierBag,
            validateBagNumber,
            setModal,
        } = this.props;

        const retNodes = [];
        const renderedForDeviceType = (deviceType==="xs" || deviceType==="sm") ? "xs" : "sm";

        for(let i=0; i<tobacco.bagSupplier.length; i++) {
            const supplier = tobacco.bagSupplier[i];
            for(let j=0; j<supplier.bags.length; j++) {
                const bag = supplier.bags[j];
                retNodes.push(
                    <div className="tobacco-cart-list-splitter-ordered" key={`header-${i}-${j}`}>
                        <ResponsiveRows gutters={false}>
                            {j===0 && (
                                <ResponsiveColumn xs={12}>
                                    <label className="supplier-name" style={{float:"left",position:"relative",paddingRight:"8px",paddingTop:"8px"}}>{`${supplier.supplierName}`}</label>
                                </ResponsiveColumn>
                            )}
                            <ResponsiveColumn xs={12}>
                                {/* eslint-disable-next-line react/jsx-no-bind */ }
                                <div style={{float:"left",position:"relative",top:"13px"}} ref={(element) => {this.setRef(element,supplier.supplierId, j);}} >
                                    <LabelField label={localization.text("history","bagnumber")} isRequired={true}/>
                                </div>
                                <TobaccoSupplierNumberField
                                    edditSupplierBag={edditSupplierBag}
                                    tobacco={tobacco}
                                    bagIndex={j}
                                    supplierId={supplier.supplierId}
                                    supplierIndex={i}
                                    localization={localization}
                                    validateBagNumber={validateBagNumber}
                                    productId={supplier.bags[0].lines.length>0?supplier.bags[0].lines[0].product.productId:"0"}
                                    maxLength={10}/>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                );
                for(let k=0; k<bag.lines.length; k++) {
                    const line = bag.lines[k];
                    retNodes.push(
                        <ProductViewListItem
                            key={`${i}-${j}-${k}`}
                            localization={localization}
                            product={line.product || {}}
                            deviceType={renderedForDeviceType}
                            addRemoveProductToTemporaryOrder={addRemoveProductToTobaccoBag}
                            list={bag}
                            border={false}
                            countOnylOrdered={false}
                            disabled={j+1!==supplier.bags.length} 
                            setModal={setModal}
                            countingNode={<CounterField/>}
                            priceInSalesUnits={true}
                        />
                    );
                }
                if( j+1===supplier.bags.length ){
                    const product = getPropertyValue(tobacco,["bagSupplier",i,"bags",j,"lines",0,"product"]);
                    const canAddBag = getPropertyValue(tobacco,["bagSupplier",i,"bags",j,"bagNumberValidated"]);
                    retNodes.push(
                        <TobaccoAddBagButton product={product} canAddBag={canAddBag} addTobaccoBag={addTobaccoBag} localization={localization} key={`button-${i}-${j}`}/>
                    );
                }
            }
        }

        return retNodes;
    }

    render(){
        const {
            localization,
            height,
            deviceType,
            tobacco,
            editTobacco,
            freightChargePickupTobacco,
        } = this.props;

        const listHeight = this.calculateListHeight();
        const estimatedValue = estimatedTobaccoReturnValue(tobacco);
        const hasAnythingBeenAdded = tobacco.bagSupplier.length>0;
        const canSubmit = hasAnythingBeenAdded && !tobacco.submitting; // && isAllBagNumberValidated(tobacco);
        const lineCount = getTobaccoReturnLineCount(tobacco);

        const renderCart = () => {
            return (
                <React.Fragment>
                    <SubMenu>
                        <SubMenuItem roundCornerTopLeft={true} interactive={false} iconType={iconTypes.recycle} />
                        <SubMenuItem interactive={false} side="left-borderless">
                            <div className="history-menu-text">
                                {localization.text("history","tobaccoReturn")}
                            </div>
                        </SubMenuItem>
                        {deviceType==="xs" && (
                            <SubMenuItem side="locked-right" onClick={this.onClickMinimize} iconType={iconTypes.down} />
                        )}
                    </SubMenu>
                    <div className="sub-menu border flex-align-center">
                        <div className="shopping-cart-menu-info">
                            <Icon type={iconTypes.list} style={{marginLeft:"9px"}}/>
                            <div className="history-in-return-cart shopping-cart-menu-info-text flex-align-center">
                                {localization.text("history","inYourReturnBags")}
                            </div>
                            { lineCount===0 ? (
                                <div className="flex-align-center">
                                    <Tag type={tagTypes.grey} label={localization.text("order","empty")} className={"tag-large"}/>
                                </div>
                            ) : ( 
                                <div className="flex-align-center">
                                    <Tag type={tagTypes.red} label={localization.text("history","lineCount",{count:lineCount})} className={"tag-large"}/>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={"product-view-header-wrapper"} >
                        <ProductViewListHeader localization={localization} deviceType={"xs"}/>
                    </div>
                    <Scroll className={"shopping-cart-list-wrapper"} style={{height:`${listHeight-34}px`}}>
                        {this.prepareCart()}
                    </Scroll>
                    <div className="tobacco-cart-bottom" style={{padding:"8px"}}>
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={12}>
                                <LabelField label={localization.text("history","tobaccoTransportation")} isRequired={true}/>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={7} sm={6}>
                                <RadioButton source={tobacco} property="pickUpByEngrospartner" value={true} label={localization.text("history","PickUpByEngrospartner")} onChange={editTobacco}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={2} sm={2} className="flex-align-center">
                                { freightChargePickupTobacco==null || !tobacco.pickUpByEngrospartner || freightChargePickupTobacco===0 ? (
                                    <div className="pickup-info">{localization.text("history","free")}</div>
                                ) : (
                                    <div className="pickup-info_with_cost">{freightChargePickupTobacco.toFixed(2)}</div>
                                )}                               
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={3} sm={4}>
                                <div className="total-cost">{localization.text("history","estimatedValue")}</div>
                                <div className="total-price">{estimatedValue.toFixed(2)}</div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={7} sm={6}>
                                <RadioButton source={tobacco} property="pickUpByEngrospartner" value={false} label={localization.text("history","DropOffAtNearestStation")} onChange={editTobacco}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={2} sm={2} className="flex-align-center">
                                <div className="pickup-info">{localization.text("history","free")}</div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={3} sm={4}>
                                <div className="total-cost">{localization.text("history","total")}</div>
                                <div className="total-price">{(tobacco.pickUpByEngrospartner?0:0).toFixed(2)}</div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={12}>
                                <LabelField label={localization.text("history","tobaccoComment")} />
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <TextField source={tobacco} property="description" onEdit={editTobacco} placeholder={localization.text("history","tobaccoCommentPlaceholder")} maxLength={255}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <div style={{paddingTop:"8px"}}>
                                    <button className="btn icon" disabled={!hasAnythingBeenAdded} onClick={this.onClickClear}>
                                        <Icon type={iconTypes.x} color={iconColor.red}/>
                                        {localization.text("history","clear")}
                                    </button>
                                    <button className="btn" onClick={this.onClickSaveTobaccoReturn}>
                                        {localization.text("history","save")}
                                    </button>
                                    <button className="btn primary" disabled={!canSubmit} onClick={this.onClickSubmitTobaccoReturn}>
                                        {localization.text("history","submit")}
                                    </button>
                                </div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </React.Fragment>
            );
        };

        return this.state.expanded ? (
            deviceType==="xs" ? (
                <React.Fragment>
                    <div className="dim-screen" onClick={this.onClickMinimize}/>
                    <div className="shopping-cart-card-expanded-tiny" style={{height:`${height+parseInt(scssVariables.cardMargin)}px`}}>
                        {renderCart()}
                    </div>
                </React.Fragment>
            ) : (
                <div className="card-default shopping-cart-card" style={{height:`${height}px`}}>
                    {renderCart()}
                </div>
            )
        ) : (
            <div className="shopping-cart-card-tiny">
                <SubMenu>
                    <SubMenuItem iconType={iconTypes.recycle} interactive={false} />
                    <SubMenuItem interactive={false} side="left-borderless">
                        <div className="history-menu-text">
                            {localization.text("history","tobaccoReturn")}
                        </div>
                    </SubMenuItem>
                    <SubMenuItem iconType={iconTypes.up} side="locked-right" onClick={this.onClickExpand} />
                </SubMenu>
            </div>
        );
    }
}

TobaccoReturnCart.propTypes = {
    localization: Localization.propTypes.isRequired,
    height: PropTypes.number.isRequired,
    deviceType: PropTypes.string.isRequired,
    tobacco: PropTypes.object.isRequired,
    addRemoveProductToTobaccoBag: PropTypes.func.isRequired,
    addTobaccoBag: PropTypes.func.isRequired,
    clearAll: PropTypes.func.isRequired,
    submitTobaccoReturn: PropTypes.func.isRequired,
    saveTobaccoReturn: PropTypes.func.isRequired,
    editTobacco: PropTypes.func.isRequired,
    edditSupplierBag: PropTypes.func.isRequired,
    validateBagNumber: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    pickupTobaccoDefault: PropTypes.bool.isRequired,
    freightChargePickupTobacco: PropTypes.number,
    width: PropTypes.number,
};

export default TobaccoReturnCart;